import {
  getThemeObjectTokens
} from "./chunk-BPL7EIXS.js";

// src/theme/font.ts
import varnishTokens from "@allenai/varnish-theme";
var font = {
  family: getThemeObjectTokens(varnishTokens.font.family),
  size: getThemeObjectTokens(varnishTokens.font.size),
  weight: getThemeObjectTokens(varnishTokens.font.weight)
};

export {
  font
};
//# sourceMappingURL=chunk-WJHMXJ4P.js.map